import { useMemo } from 'react';
import { DropdownItemProps } from 'semantic-ui-react';
import {
  FORM_FIELD_NAMES,
  REQUIRED_FILTERS,
} from '../../pages/MyContent/ManagePreferencesTab/Preferences/AddPreferencesModal/AddPreferencesModal.constants';
import { FilterFieldOptions } from '../../pages/MyContent/ManagePreferencesTab/Preferences/AddPreferencesModal/AddPreferencesModal.types';
import useFetchFilters from '../tags/useFetchFilters';

export interface UseFilterFieldOptions {
  options: FilterFieldOptions;
  subsectorOptionsBySector: Record<string, DropdownItemProps[]>;
  isLoading: boolean;
}

const useFilterFieldOptions = (): UseFilterFieldOptions => {
  const { data: filters, isLoading } = useFetchFilters(REQUIRED_FILTERS);

  const subsectorOptionsBySector = useMemo<Record<string, DropdownItemProps[]>>(() => {
    const result: Record<string, DropdownItemProps[]> = {};
    if (filters) {
      const sectorFilter = filters.filter((filter) => filter.type === FORM_FIELD_NAMES.sector)[0];
      sectorFilter.options.forEach((sector) => {
        const subSectorOptions = sector.children?.map((subSector) => ({
          text: subSector.displayName,
          value: subSector.tagId,
          key: subSector.tagId,
        }));
        if (subSectorOptions) {
          result[sector.tagId] = subSectorOptions;
        }
      });
    }

    return result;
  }, [filters]);

  const options = useMemo<FilterFieldOptions>(() => {
    const result: FilterFieldOptions = {
      [FORM_FIELD_NAMES.creditGrade]: [],
      [FORM_FIELD_NAMES.sector]: [],
      [FORM_FIELD_NAMES.topic]: [],
      [FORM_FIELD_NAMES.region]: [],
      [FORM_FIELD_NAMES.subsector]: [],
      [FORM_FIELD_NAMES.analyst]: [],
      [FORM_FIELD_NAMES.report]: [],
      [FORM_FIELD_NAMES.assetClass]: [],
    };
    if (filters) {
      filters.forEach((filter) => {
        result[filter.type] = filter.options.map((option) => {
          return {
            text: option.displayName,
            value: option.tagId,
            key: option.tagId,
          };
        });
      });
    }

    return result;
  }, [filters]);

  return { options, subsectorOptionsBySector, isLoading };
};

export default useFilterFieldOptions;
